module.exports = __webpack_public_path__ + "img/album05_14.e2558cf6.jpg";